import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const MapPinIcon = ({
  width = 16,
  height = 16,
  stroke = '#52575C',
  strokeWidth = 1.5,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
  >
    <g
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      clipPath="url(#clip0)"
    >
      <path d="M14 6.667c0 4.667-6 8.667-6 8.667s-6-4-6-8.667c0-1.591.632-3.117 1.757-4.243C4.883 1.3 6.41.667 8 .667c1.591 0 3.117.632 4.243 1.757C13.368 3.55 14 5.076 14 6.667z" />
      <path d="M8 8.667c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z" />
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H16V16H0z" />
      </clipPath>
    </defs>
  </svg>
);
